import Text from 'Components/ComponentLibrary/Atoms/Text';
import React from 'react';
import PropTypes from 'prop-types';
import { FDIcon, FDPaper, FDStack } from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';

function NoOneTimeExpensesContainer({ description }) {
  return (
    <FDPaper
      width={'100%'}
      padding={2}
      {...dataAttrs('no-one-time-expenses-container')}
    >
      <FDStack paddingY={3} spacing={3} direction={'column'} alignItems={'center'}>
        <FDIcon size={'xl'} color={'info'} icon={'squareDollarOceana'} />
        <Text
          variant="h5"
          color="black"
          weight={'medium'}
          value={description}
        />
      </FDStack>
    </FDPaper>
  );
}

NoOneTimeExpensesContainer.propTypes = {
  description: PropTypes.string.isRequired,
};

NoOneTimeExpensesContainer.defaultProps = {
};

export default NoOneTimeExpensesContainer;
